import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { orgActions, userActions } from "../../actions";
import { Link, useLocation } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { DEBUG_STATE } from "../../constants/constants.js";

function DocTypeUsers(props) {
  const { authentication, org, getOrgUsers, getOrgDetail, assignDoctypeToUser, removeDoctypeFromUser } = props;
  const org_detail = org.org_detail;
  const current_org_id = org.current_org_id;
  
  const org_users = org.org_users;
  const current_org_users = org_users?.filter((user) => user.org_id === current_org_id);

  const location = useLocation();
  const {doctype} = location.state;
  const debug = DEBUG_STATE;

  const cancelicon = require("../../images/status-red.png").default;
  const saveicon = require("../../images/status-green.png").default;

  const [oldUserDoctypeMap, setOldUserDoctypeMap] = useState(new Map());
  const [newUserDoctypeMap, setNewUserDoctypeMap] = useState(new Map());

  useEffect(() => {
    getOrgUsers(current_org_id);
    getOrgDetail(current_org_id);
  }, [current_org_id])

  useEffect(() => { 
    const buildDoctypeMap = () => {
      const userMap = new Map();
      for (const user of current_org_users) {
        if (user.doctypes.length < 1) {
          setOldUserDoctypeMap(new Map(oldUserDoctypeMap.set(user.user_id, false)));
        }
        var has_doctype = false;
        for (const type of user.doctypes) {
          if (type.doc_type_name === doctype.doc_type) {
            has_doctype = true;
            setOldUserDoctypeMap(new Map(oldUserDoctypeMap.set(user.user_id, true)));
          }
        }
        if (!has_doctype) {
          setOldUserDoctypeMap(new Map(oldUserDoctypeMap.set(user.user_id, false)))
        }
      }
      
    };
    if (org.org_users) {
      buildDoctypeMap();
      setNewUserDoctypeMap(oldUserDoctypeMap);
    }
    
  }, [org.org_users]);

  useEffect(() => {
    if (debug) console.log(newUserDoctypeMap);
  }, [oldUserDoctypeMap])

  const updateUserDoctypeMap = (key, value) => {
    setNewUserDoctypeMap(map => new Map(newUserDoctypeMap.set(key, value)));
    if (debug) console.log(newUserDoctypeMap);
  }

  //if (debug) console.log (doctype);

  const handleSubmit = () => {
    if (debug) {
      console.log("old:");
      console.log(oldUserDoctypeMap);
      console.log("new:");
      console.log(newUserDoctypeMap);
    };

    for (const [user_id, assign] of newUserDoctypeMap.entries() ) {
      if (assign !== oldUserDoctypeMap.get(user_id)) {
        const requestObject = { userId: Number(user_id), orgId: Number(current_org_id), docTypeName: doctype.doc_type};
        if (assign) {
          assignDoctypeToUser(requestObject);
        } else {
          removeDoctypeFromUser(requestObject);
        }
      } 
    }
  }

  const handleDocTypeChange = (user) => {
    updateUserDoctypeMap(user.user_id, !newUserDoctypeMap.get(user.user_id));

  }


  const tableHead = (  
    <thead>
      <tr>
        <th>email</th>
        <th>primary org</th>
        <th>        
          <span className="docTypeLabel" style={{backgroundColor: "#"+doctype.color}} >
              {doctype.labelCode}
          </span>&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;
          {doctype.doc_type}
        </th>
      </tr>
    </thead>
  );


  function mapUserArrayToTableRows(users) {
    const output = users?.length === 0 ? null :
      users?.map((user, i) => (
        <>
          <tr key={user.user_id}>
            <td>
              <Link
                to={{
                  pathname: "/user/" + user.user_id,
                  state: { user_to_edit: user },
                }}
              >
                {user.email}
              </Link>
            </td>
            <td>
              {user.org_name}
            </td>
            <td>
              {
                newUserDoctypeMap.get(user.user_id) &&
                <input type="checkbox" checked onChange={() => handleDocTypeChange(user)}/>
              }
              {
                !newUserDoctypeMap.get(user.user_id) &&
                <input type="checkbox" onChange={() => handleDocTypeChange(user)}/>
              }
              
            </td>
          </tr>
        </>
      ));

    return output;
  }


  return (
    <div class="searchMain">
      <h3>
        Assign Users to Document Type
        &nbsp;&nbsp;&nbsp;
        <div className="editJacketNameIcon" onClick="" data-tip data-for="cancel">
          <Link
            to={{
              pathname: "/org/" + current_org_id + "/doctypes" 
            }}
          >
            <img src={cancelicon} className="cancelImage" width="20px" alt="cancel" />
          </Link>
        </div>
        &nbsp;&nbsp;&nbsp;
        <ReactTooltip id="cancel" place="bottom" effect="solid" data-type="info" delayShow={200}>
          go back
        </ReactTooltip>
        <div className="editJacketNameIcon" onClick="" data-tip data-for="save" >
          <img src={saveicon} className="saveImage" width="20px" alt="save" onClick={() => handleSubmit()} />
        </div>
        <ReactTooltip id="save" place="bottom" effect="solid" data-type="info" delayShow={200}>
          save
        </ReactTooltip>      
      
      </h3>          
      <br/><br/>
      <table className="paleBlueRows narrow">
        {tableHead}
        <tbody>
          {mapUserArrayToTableRows(current_org_users)}
        </tbody>
      </table>
      <br /><br />

    </div>
  );
}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org,
  };
}

const actionCreators = {
  getOrgUsers: orgActions.getOrgUsers,
  getOrgDetail: orgActions.getOrgDetail,
  assignDoctypeToUser: userActions.assignDoctypeToUser,
  removeDoctypeFromUser: userActions.removeDoctypeFromUser
};

const connectedDocTypeUsers = connect(mapStateToProps, actionCreators)(DocTypeUsers);
export { connectedDocTypeUsers as DocTypeUsers };
